import axios from 'axios'

const url = 'http://10.1.110.121:8000/publicaciones'
const state = {
  endpoints: {
    scimago: url + '/scimagos/',
  },
  scimago_revistas: [],
}


const mutations = {
  async listarRevistasScimago(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.scimago, {
    }).then((response) => {
      state.scimago_revistas = response.data
    }).catch(error => {
      state.scimago_revistas = []
    })
  },
  changeRevistas(state, revistas){
    state.scimago_revistas = revistas
  }
}

const actions = {
  getRevistasScimago({commit}) {
    commit('listarRevistasScimago')
  },
  setRevistasScimago({commit}, revistas) {
    commit('changeRevistas',revistas)
  },
}

const getters = {
  scimago_revistas: (state) => {
    return state.scimago_revistas
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/storage/modules/directorio.js